export const colors = {
  primary: '#2ABFA7',
}
